<form #formRef="ngForm">
	<bb-page-header [backOnMobile]="['/library/playlists']" [icon]="'list-ol'" [title]="playlist?.title"
		[tabItems]="entityConfiguration.tabItems" [inModal]="routeOutlet === 'modal'">

		<span class="subtitle"> {{ playlist?.label }} </span>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'ACTIVE' | translate"
			[labelOff]="'INACTIVE' | translate"></bb-status>

	</bb-page-header>

	<div class="body-column tab-container" cdkScrollable>
		<playlist-details-general *ngIf="entity && tabLoadedBefore('general')"
			[queryFromTableService]="queryFromTableService" [form]="form" [playlist]="entity"
			[hidden]="activeTab !== 'general'" (onPlaylistFilterChange)="onPlaylistFilterChange($event)"
			(onPlaylistQueryChange)="onPlaylistQueryChange($event)" (sortOrderChange)="sortOrderChange($event)"
			(addedSelectedClips)="addedSelectedClips($event)"></playlist-details-general>
		<playlist-details-rss *ngIf="entity && tabLoadedBefore('rss')" [form]="form" [playlist]="entity"
			[hidden]="activeTab !== 'rss'"></playlist-details-rss>
		<playlist-details-embed *ngIf="entity && tabLoadedBefore('embed')" [form]="form"
			[hidden]="activeTab !== 'embed'" [playlist]="entity" [isActive]="activeTab === 'embed'">
		</playlist-details-embed>
	</div>

	<div class="body-column preview-container">
		<div class="sort-property">
			<ng-container *ngIf="playlist?.listtype === 'static'">
				<h2>{{ 'SELECTED_CONTENT' | translate }}</h2>
				<bb-button (click)="addToWorklist(entity.items)">
					<i class="spacing fa fa-paperclip"></i>{{ 'ADD_ALL_TO_WORKLIST' | translate }}
				</bb-button>
			</ng-container>
			<ng-container *ngIf="playlist?.listtype === 'dynamic'">
				<h2>{{ 'SELECTED_CONTENT' | translate }}</h2>
				<bb-button (click)="addToWorklist(rows)">
					<i class="spacing fa fa-paperclip"></i>{{ 'ADD_ALL_TO_WORKLIST' | translate }}
				</bb-button>
			</ng-container>
		</div>

		<ng-container *ngIf="playlist?.useSuggest !== 'true'">
			<div class="line">
				<label>{{ 'VODCAST_URL' | translate }}</label>
				<a class="blue" [href]="baseUrl + '/vodcast/' + playlist?.id" target="_blank">
					https:{{ baseUrl }}/vodcast/{{ playlist?.id }}
				</a>
			</div>
			<div class="line">
				<label>{{ 'TOTAL_ITEMS' | translate }}</label>
				<span *ngIf="playlist?.listtype === 'dynamic'">{{ rowsTotal }} </span>
				<span *ngIf="playlist?.listtype === 'static'">{{ entity.items.length }} </span>
			</div>
			<div class="line">
				<label>{{ 'TOTAL_PLAYTIME' | translate }}</label>
				<div>
					<p>{{ playTime | seconds }} <small *ngIf="playTime > 0">&nbsp;
							{{ playTime | seconds : 'long' }}</small></p>
					<p *ngIf="showProjectPlaytimeWarning" class="message">
						{{ "TOTAL_PLAYTIME_PROJECT_WARNING" | translate }}
					</p>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="playlist?.useSuggest === 'true'">
			<div class="suggests-info message info">
				<i class="fa fa-info"></i> {{ 'SUGGESTS_SELECTED_CONTENT' | translate }}
			</div>
		</ng-container>
		<div class="line" *ngIf="playlist?.listtype === 'static'">
			<label>{{ 'SORT_BY' | translate }}</label>
			<div class="sort-property">
				<bb-select [(ngModel)]="filterSort.property" [options]="sortPropertyOptions" name="filterSort-property"
					[ngModelOptions]="{standalone: true}">
				</bb-select>
				<bb-select [(ngModel)]="filterSort.direction" name="filterSort-direction"
					[ngModelOptions]="{standalone: true}">
					<option value="asc">{{ 'ASCENDING' | translate | lowercase }}</option>
					<option value="desc">{{ 'DESCENDING' | translate | lowercase }}</option>
				</bb-select>
				<bb-button (click)="manualSort()">
					<i class="spacing fa fa-sort"></i>{{ 'SORT' | translate}}
				</bb-button>
			</div>
		</div>

		<!-- Dynamic playlist -->
		<bb-table-container *ngIf="playlist?.listtype === 'dynamic'">
			<bb-table-header>
				<bb-table-header-cell class="thumb"></bb-table-header-cell>
				<bb-table-header-cell class="icon"></bb-table-header-cell>
				<bb-table-header-cell>{{ 'ID' | translate }}</bb-table-header-cell>
				<bb-table-header-cell class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
				<bb-table-header-cell class="column-statusicon">&nbsp;</bb-table-header-cell>
				<bb-table-header-cell class="buttons"></bb-table-header-cell>
			</bb-table-header>

			<ng-container *ngFor="let row of rows">
				<bb-table-row *ngIf="row.data" [row]="row">
					<bb-table-cell class="thumb">
						<bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
					</bb-table-cell>
					<bb-table-cell>
						<span style="white-space: no-break;">
							<span [innerHTML]="row.data | clipIcon"></span>
							<strong [hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;"
								title="Creative">C</strong>
						</span>
					</bb-table-cell>
					<bb-table-cell>{{ row.data.id }}</bb-table-cell>
					<bb-table-cell class="overflow">
						<span [hidden]="!row?.data?.title">{{ row.data.title }}</span>
						<span [hidden]="row?.data?.title" class="filename">{{ row.data.originalfilename }}</span>
					</bb-table-cell>
					<bb-table-cell class="column-statusicon">
						<div [innerHtml]="row.data | statusIcon"></div>
					</bb-table-cell>
					<bb-table-cell class="buttons">
						<a class="button" [routerLink]="['/library/' + (row.data.type === 'MediaClipList' ? 'playlist' : row.data.type.toLowerCase()) + '/', row.data.id, row.data.type === 'MediaClipList' ? 'general' : 'metadata']">
							<i class="fa fa-edit"></i>
						</a>
						<a class="button" (click)="showPreview(row.data)">
							<i class="fa fa-eye"></i>
						</a>
					</bb-table-cell>
				</bb-table-row>
			</ng-container>
		</bb-table-container>

		<div class="no-results" *ngIf="playlist?.listtype === 'dynamic' && rows && !rows.length">
			{{ 'NO_RESULTS_FOUND_OR_INCORRECT_QUERY' | translate }}
		</div>

		<!-- Static playlist -->
		<bb-table-container *ngIf="playlist?.listtype === 'static'" cdkDropList (cdkDropListDropped)="reorder($event)">
			<bb-table-header>
				<bb-table-header-cell class="icon"></bb-table-header-cell>
				<bb-table-header-cell class="thumb"></bb-table-header-cell>
				<bb-table-header-cell class="icon"></bb-table-header-cell>
				<bb-table-header-cell>{{ 'ID' | translate }}</bb-table-header-cell>
				<bb-table-header-cell class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
				<bb-table-header-cell class="column-statusicon">&nbsp;</bb-table-header-cell>
				<bb-table-header-cell class="buttons"></bb-table-header-cell>
			</bb-table-header>

			<bb-table-row *ngFor="let row of entity.items; let i = index; trackBy: trackByIndex" [row]="row" cdkDrag cdkDragLockAxis="y">
				<bb-table-cell class="drag"><i class="fa fa-bars"></i></bb-table-cell>>
				<bb-table-cell class="thumb">
					<bb-table-thumbnail [entity]="row"></bb-table-thumbnail>
				</bb-table-cell>
				<bb-table-cell>
					<span style="white-space: no-break;">
						<span [innerHTML]="row | clipIcon"></span>
						<strong [hidden]="row.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;"
							title="Creative">C</strong>
					</span>
				</bb-table-cell>
				<bb-table-cell>{{ row.id }}</bb-table-cell>
				<bb-table-cell class="overflow">
					<span [hidden]="!row?.title">{{ row.title }}</span>
					<span [hidden]="row?.title" class="filename">{{ row.originalfilename }}</span>
				</bb-table-cell>
				<bb-table-cell class="column-statusicon">
					<div [innerHtml]="row | statusIcon"></div>
				</bb-table-cell>
				<bb-table-cell class="buttons">
					<a class="button" (click)="unlinkItem(row, i)">
						<i class="fa fa-unlink"></i>
					</a>
					<a class="button" (click)="showPreview(row)">
						<i class="fa fa-eye"></i>
					</a>
				</bb-table-cell>
			</bb-table-row>

		</bb-table-container>

		<div class="no-results" *ngIf="playlist?.listtype === 'static' && playlist?.items && !playlist?.items.length">
			{{ 'NO_CONTENT_SELECTED' | translate }}
		</div>
		<bb-table-pager [total]="rowsTotal"></bb-table-pager>

		<bb-entity-details [entity]="entity"></bb-entity-details>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form"
	[entity]="entity">
</bb-actions-bar>
